import { render, staticRenderFns } from "./imports-data-table.vue?vue&type=template&id=88b784d8&scoped=true&"
import script from "./imports-data-table.vue?vue&type=script&lang=js&"
export * from "./imports-data-table.vue?vue&type=script&lang=js&"
import style0 from "./imports-data-table.vue?vue&type=style&index=0&id=88b784d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b784d8",
  null
  
)

export default component.exports